import { IContent } from 'json-as-xlsx';

export const REPORT_SHEET_NAME = 'ooc_report';

export const REPORT_COLUMNS = [
  {
    label: 'Campaign ID',
    value: (row: IContent) => row.userVisibleId || row.campaignId,
  },
  {
    label: 'Sales team',
    value: 'salesTeam',
  },
  {
    label: 'Sales person',
    value: 'salesPerson',
  },
  {
    label: 'Admin person',
    value: 'adminPerson',
  },
  {
    label: 'Brand',
    value: 'brand',
  },
  {
    label: 'Status',
    value: 'status',
  },
  {
    label: 'Start date',
    value: 'campaignStartDate',
  },
  {
    label: 'End date',
    value: 'campaignEndDate',
  },
  {
    label: 'Route frame code',
    value: 'routeFrameCode',
  },
  {
    label: 'Furniture ID',
    value: 'furnitureId',
  },
  {
    label: 'Product format',
    value: 'productFormat',
  },
  {
    label: 'Business area',
    value: 'businessArea',
  },
  {
    label: 'Size code',
    value: 'sizeCode',
  },
  {
    label: 'Media type',
    value: 'mediaType',
  },
  {
    label: 'Route town',
    value: 'routeTown',
  },
  {
    label: 'Address',
    value: 'address',
  },
];
